import { render, staticRenderFns } from "./ChangeAdmin.vue?vue&type=template&id=16617ff8&"
import script from "./ChangeAdmin.vue?vue&type=script&lang=ts&"
export * from "./ChangeAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeAdmin.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports